export const BINGO_SCHEDULER = 'bingoscheduler';
